import React from "react";
import { Portait6Style } from "./css/Portrait6Style";
import TemplateImage from "../../components/editor/Templates/TemplateImage";
import TemplateLogo from "../../components/editor/Templates/TemplateLogo";
import TemplateWatermark from "../../components/editor/Templates/TemplateWatermark";
import TemplateText from "../../components/editor/Templates/TemplateText";

const Template = (props) => {
  return (
    <Portait6Style>
      <div className="template-wrapper">
        <div className="poster six nine-by-sixteen">
          <TemplateLogo logo={props.logo} />
          <TemplateWatermark watermark={props.watermark} />
          <div className="flex-column">
            <div className="photo-container flex-column">
              <div className="photo">
                <TemplateImage slideType={props.slideType} file={props.file} />
              </div>
            </div>
            <div className="subflex-center text-wrapper">
              <TemplateText
                id={props.id}
                text={props.text}
                textStyle={props.textStyle}
                editStatus={props.editStatus}
                onInputSlideText={props.onInputSlideText}
              />
            </div>
          </div>
        </div>
      </div>
    </Portait6Style>
  );
};

export default Template;
